import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';

/*
  Generated class for the ExchangeNoticeProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ExchangeNoticeProvider {
  constructor(public http: HttpProvider) {
    console.log('Hello ExchangeNoticeProvider Provider');
  }

  getExchangeList() {
    return this.http.hPost('/get_s_announcement_list_and_status');
  }

  switchAExchange(platform_id, is_switch) {
    let params = {
      switch: is_switch,
      platform_id: platform_id,
    };
    return this.http.hPost('/switch_a_s_announcement_effect', params);
  }

  switchExchange(is_switch) {
    return this.http.hPost('/switch_func_synchronous_announcement', {
      switch: is_switch,
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/exchange-notice/exchange-notice.ts